import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        autoShow: Boolean,
        modalType: String
    };
    static targets = [];

    connect() {
        console.debug("Responsive Modal connected", this.autoShowValue);
        if (this.modalTypeValue === 'offcanvas') {
            // keyboard:false so Esc on a layered child modal does not also
            // dismiss the parent offcanvas — the child handles its own Esc.
            this.modal = new bootstrap.Offcanvas(this.element, {backdrop: 'static', keyboard: false});
        } else {
            this.modal = new bootstrap.Modal(this.element, {backdrop: 'static'});
        }

        // Auto-wire backdrop tracking so the scoped cleanup in modalHidden works
        // even if a consumer forgets the explicit shown.bs.* data-action. Bootstrap
        // dispatches the same event regardless of how show() was triggered.
        this.boundRememberBackdrop = this.rememberBackdrop.bind(this);
        this.element.addEventListener('shown.bs.modal', this.boundRememberBackdrop);
        this.element.addEventListener('shown.bs.offcanvas', this.boundRememberBackdrop);

        if (this.autoShowValue) {
            this.modal.show();
        }
    }

    disconnect() {
        if (this.boundRememberBackdrop) {
            this.element.removeEventListener('shown.bs.modal', this.boundRememberBackdrop);
            this.element.removeEventListener('shown.bs.offcanvas', this.boundRememberBackdrop);
        }
    }

    rememberBackdrop() {
      // Bootstrap appends the backdrop as the next sibling of the overlay element
      // on show. Capture the reference so modalHidden can remove only OUR backdrop
      // and not yank a sibling overlay's backdrop (e.g., a layered status modal).
      const next = this.element.nextElementSibling;
      if (next && (next.classList.contains('offcanvas-backdrop') || next.classList.contains('modal-backdrop'))) {
        this.ownBackdrop = next;
      }
    }

    open(event) {
        console.debug("Responsive Modal: Frame load (open)", event);

        if (!this.modal.isOpened) {
            this.modal.show();
        }
    }

    hide() {
        this.modal.hide();
    }

    /**
     * Called when the event hidden.bs.offcanvas or hidden.bs.modal is triggered
     */
    modalHidden(event) {
      // Bootstrap offcanvas/modal events bubble. Without this guard a descendant
      // overlay's hidden event would trigger the parent's self-destruct, taking
      // both subtrees out of the DOM mid-interaction.
      if (event.target !== this.element) return;

      console.debug("Modal has been hidden", event);

      this.modal.dispose();
      this.element.remove();
      console.debug("Modal has been cleaned");

      // Scoped backdrop cleanup: only remove the backdrop owned by this overlay,
      // tracked via shown.bs.{modal,offcanvas} → rememberBackdrop. The previous
      // unconditional `document.querySelector('.modal-backdrop').remove()` would
      // yank a sibling overlay's backdrop (e.g., a layered status modal sitting
      // alongside a reservation detail offcanvas).
      if (this.ownBackdrop && this.ownBackdrop.isConnected) {
        this.ownBackdrop.remove();
      }
      this.ownBackdrop = null;
    }

    close(event) {
        console.debug("Responsive Modal: Submit end", event);

        if (event.detail.success) {
            this.modal.hide();
        }
    }
}

